<template lang="pug">
.card-choose-list-container(v-if="aggCardList.length>1")
  .card-choose-list(v-for="(item, index) in aggCardList")
    .card-item(:class="index===chooseIndex?'chooseOne':''" @click="chooseCard(index)"
    :style="aggCardList.length>3?'width:1rem':''")
      span {{item.propEffectiveDays}}天
      span {{item.propTimes}}次卡
      .card-logo(v-if="index===chooseIndex")
        img.logo(src="https://m.hellobike.com/resource/gallery/61/oXOdLojp_Stroke%203.png?x-oss-process=image/quality,q_80")
</template>
<script>
import eventBus from '@/const/eventBus.js';

export default {
  props: {
    aggCardList: {
      type: Array,
      default: () => [],
    },
    anchoredVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chooseIndex: 0,
    };
  },
  watch: {

  },
  destroyed() {

  },
  created() {
    this.chooseIndex = this.aggCardList.findIndex((item) => item.propVersion === this.anchoredVersion);
    if (this.chooseIndex >= 0) {
      eventBus.$emit('chooseAggCard', this.aggCardList[this.chooseIndex]);
    } else {
      eventBus.$emit('chooseAggCard', this.aggCardList[0]);
    }
  },
  methods: {
    chooseCard(index) {
      this.chooseIndex = index;
      this.$emit('chooseCard', index);
      eventBus.$emit('chooseAggCard', this.aggCardList[index]);
    },
  },
};
</script>
<style lang="less" scoped>
.card-choose-list-container {
  display: flex;
  overflow: auto;
  margin-bottom: -0.04rem;

  .card-choose-list {
    margin-top: 0.12rem;
    justify-content: flex-start;
    // overflow-y: hidden;

    .card-item {
      background: #e6f4ff;
      color: #5a6066;
      font-family: PingFang SC;
      font-size: 0.12rem;
      font-weight: 500;
      border-radius: 0.08rem;
      margin-right: 0.1rem;
      height: 0.28rem;
      line-height: 0.28rem;
      padding: 0 0.16rem;
      position: relative;
      text-align: center;
      word-wrap: normal;
      word-break: keep-all;

      .card-logo {
        width: 0.13rem;
        height: 0.1rem;
        background: #08f;
        border-radius: 0 0.06rem 0 0.06rem;
        position: absolute;
        top: 0;
        right: 0;

        img.logo {
          position: absolute;
          top: 0.03rem;
          right: 0.03rem;
          width: 0.062rem;
          height: 0.042rem;
        }
      }
    }

    .chooseOne {
      border: 0.5px solid #0088FF;
      line-height: 0.26rem;
      color: #08f;
    }
  }
}

::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari 和 Opera */
}
</style>
